/**
 * Dashboard - IPSec VPN Store
 *
 * @since 2018-08-16
 * @author ms1124.kim
 *
 */
import JSONBigInt from 'json-bigint'

// Prefix
const analysisApiPath = '/api/an/analysis'

export const state = () => ({})

export const mutations = {}

export const actions = {
  /*
    이름: startAnalysisData
    설명: 분석 데이터 조회를 시작한다.
  */
  async startAnalysisData ({commit, state}, analysisParams) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$post(`${analysisApiPath}/start`, analysisParams, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisStatus
    설명: 조회중인 분석 데이터의 상태를 가져온다.
  */
  async getAnalysisStatus ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/status`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisData
    설명: 분석이 중지 / 완료된 데이터를 가져온다.
  */
  async getAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisApiPath}/${requestId}/result`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: stopAnalysisData
    설명: 조회중인 작업을 중지하고 현재까지의 결과를 리턴한다.
  */
  async stopAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/stop'}`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: endAnalysisData
    설명: 조회 작업이 완료되면 호출된다. 서버의 리소스를 해제하는 명령어이므로 반드시 호출한다.
  */
  async endAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisApiPath}/${requestId}${'/end'}`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  }
}
export const getters = {}
export const strict = false
